import React, { useState, useEffect } from "react";
import clsx from "clsx";
import CustomAppBar from "../CustomComponents/CustomAppBar/CustomAppBar";
import CustomToolbar from "../CustomComponents/CustomToolbar/CustomToolbar";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import { useStyles } from '../../assets/jss/Layout';
import Logo from "../../assets/images/Logo.png";
import {
    logOutUser,
    getSession,
    getUserData,
    setRequstUrl,
    getUserRBAC,
} from "../../services/LocalStorageService";
import PageLoader from "../PageLoader/PageLoader";
import Footer from "../Footer/Footer";
import qs from "querystring";
import { EntityAccess, RBAC_CODE } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function ContentLayout(props) {
    const params = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const [userData] = React.useState(getUserData);
    const [userSession] = React.useState(getSession);
    const [isSessionValid, setIsSessionValid] = useState(true);
    const [statusCode] = useState({
        status: {
            code: 401,
            message:
                t("YOUR_SESSION_EXPIRED_PLEASE_LOGIN_AGAIN"),
        },
    });
    const [contentIdParam, setContentIdParam] = useState(null);
    const [emailTokenParam, setEmailTokenParam] = useState(null);
    const [emailTokenParamExist, setEmailTokenParamExist] = useState(null);
    const [mobileTokenParam, setMobileTokenParam] = useState(null);
    const [mobileTokenParamExist, setMobileTokenParamExist] = useState(null);
    const [getRBAC_ContentPreview] = React.useState(
        getUserRBAC(RBAC_CODE.CONTENT_PREVIEW, props)
    );
    //console.log('classes : ',classes);
    useEffect(() => {
        if (props) {
            setContentIdParam(props.match.params.id ? props.match.params.id : null);
            const queryParams = qs.parse(props.location.search);
            setEmailTokenParam(
                queryParams["?et"] ? queryParams["?et"] : null
            );
            setMobileTokenParam(
                queryParams["?mobileToken"] ? queryParams["?mobileToken"] : null
            );
            setEmailTokenParamExist(queryParams["?et"] ? true : false);
            setMobileTokenParamExist(queryParams["?mobileToken"] ? true : false);
        }
    }, [props]);

    React.useEffect(() => {
        if (
            emailTokenParamExist === true ||
            emailTokenParamExist === false ||
            mobileTokenParamExist === true ||
            mobileTokenParamExist === false
        ) {
            if (userSession || emailTokenParam || mobileTokenParam) {
                const currentDate = new Date();
                const currentDateUTC = new Date(currentDate.toUTCString());
                const tokenExpiry = new Date(
                    userSession && userSession.expiresOn && userSession.expiresOn
                );
                const tokenExpiryUTC = new Date(tokenExpiry.toUTCString());
                if (
                    tokenExpiryUTC > currentDateUTC ||
                    emailTokenParam ||
                    mobileTokenParam
                ) {
                    setIsSessionValid(true);
                } else {
                    setIsSessionValid(false);
                    setTimeout(() => {
                        userSession && logOutUser();
                        props.children.props.history.push("/login");
                    }, 200);
                }
            } else {
                if (contentIdParam) {
                    if (params.impersonationid) {
                        setRequstUrl({
                            hash: "",
                            pathname: `/impersonation/${params.impersonationid}/contents/${contentIdParam}`,
                            search: "",
                        });
                    } else {
                        setRequstUrl({
                            hash: "",
                            pathname: `/contents/${contentIdParam}`,
                            search: "",
                        });
                    }
                } else {
                    if (params.impersonationid) {
                        setRequstUrl({
                            hash: "",
                            pathname: `/impersonation/${params.impersonationid}/engagement`,
                            search: "",
                        });
                    } else {
                        setRequstUrl({
                            hash: "",
                            pathname: `/engagement`,
                            search: "",
                        });
                    }
                }
                setIsSessionValid(false);
                setTimeout(() => {
                    userSession && logOutUser();
                    props.children.props.history.push("/login");
                }, 200);
            }
        }
    }, [userSession, emailTokenParam, emailTokenParamExist]);

    return (
        <>
            {isSessionValid ? (
                <>
                    <div className={clsx(classes.root)}>
                        {getRBAC_ContentPreview && getRBAC_ContentPreview.isAccessible === EntityAccess.ALLOWED ? (
                            <CustomAppBar
                                id="header"
                                position="fixed"
                                className={clsx(classes.appBar)}
                            >
                                <CustomToolbar className={classes.toolbar}>
                                    <CustomBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        flexGrow={1}
                                    >
                                        <CustomLink href="/">
                                            <img src={Logo} alt="Logo" className={classes.logo} />
                                        </CustomLink>
                                        <CustomBox
                                            display="flex"
                                            alignItems="center"
                                            flexDirection="row"
                                        >
                                            <CustomTypography
                                                component="h3"
                                                variant="h3"
                                                className={classes.contentLayoutTitle}
                                            >
                                                {t("PREVIEW_CONTENT")}
                                            </CustomTypography>
                                        </CustomBox>
                                    </CustomBox>
                                </CustomToolbar>
                            </CustomAppBar>
                        ) : null}
                        <main className={classes.contentWithoutSideBar}>
                            <div className={classes.toolbar} />
                            <CustomBox className={classes.contentWithoutSideBarInner}>
                                {isSessionValid && props.children}
                            </CustomBox>
                        </main>
                    </div>
                    <Footer />
                </>
            ) : (
                <>
                    <PageLoader apiStatus={statusCode} />
                </>
            )}
        </>
    );
}
